import { useReveal } from "../../hooks/useReveal";

const painPoints = [
  "Sei stanco di non avere risultati adeguati con i tuoi investimenti.",
  "Non hai una strategia chiara e trasparente.",
  "Non vieni seguito periodicamente dalla stessa figura di riferimento.",
  "Sei passivo sui tuoi investimenti, ma sai che è possibile fare di più.",
  "Vuoi mettere finalmente ordine nel tuo patrimonio.",
  "Hai liquidità ferma e non sai come investirla.",
  "Hai investimenti, ma non sai se sono coerenti con i tuoi obiettivi.",
  "Prendi decisioni nei momenti sbagliati.",
  "Ti affidi alla banca senza capire davvero cosa stai facendo.",
];

export const Identificati = () => {
  const r1 = useReveal();
  const r2 = useReveal();
  return (
    <section
      id="identificati"
      data-testid="identificati-section"
      className="bg-navy text-ivory py-20 md:py-28"
    >
      <div className="container-editorial grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div ref={r1} className="reveal lg:col-span-5 lg:sticky lg:top-32 self-start">
          <p className="overline text-goldSoft mb-6">Ti riconosci?</p>
          <h2 data-testid="identificati-title" className="display-2 text-ivory">
            Forse stai vivendo<br />
            una di <em className="italic text-goldSoft">queste situazioni</em>.
          </h2>
          <p className="lede text-ivory/70 mt-8 max-w-md">
            Se anche solo una di queste frasi ti rappresenta, probabilmente è arrivato
            il momento di un confronto. Non per vendere nulla — per fare chiarezza.
          </p>
          <button
            data-testid="identificati-cta"
            onClick={() => {
              const el = document.getElementById("contatti");
              if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
            }}
            className="btn-primary bg-ivory text-navy hover:bg-goldSoft mt-10"
          >
            Parliamone
          </button>
        </div>

        <ul ref={r2} className="reveal lg:col-span-7">
          {painPoints.map((p, i) => (
            <li
              key={i}
              data-testid={`pain-${i}`}
              className="flex items-start gap-5 py-6 border-b border-ivory/15 group"
            >
              <span className="font-serif text-2xl md:text-3xl text-goldSoft leading-none w-12 shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="text-base md:text-lg leading-relaxed text-ivory/85 group-hover:text-ivory transition-colors">
                {p}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
